import { Box, BoxProps, createStyles, MantineTheme, MantineThemeOther } from "@mantine/core";
import { PolymorphicComponentProps } from "@mantine/utils";
import React from "react";

export interface RpiTextProps {
  type?: keyof MantineThemeOther["fontTypes"];
  weight?: keyof MantineThemeOther["fontWeights"];
  ellipsis?: boolean;
  color?: React.CSSProperties["color"] | ((theme: MantineTheme) => React.CSSProperties["color"]);
}

const useRpiTextStyles = createStyles<"root", RpiTextProps & Required<Pick<RpiTextProps, "type" | "weight">>>(
  (theme, { type, weight, ellipsis, color }) => {
    return {
      root: {
        fontWeight: theme.other.fontWeights[weight],
        ...theme.other.fontTypes[type],
        ...(ellipsis && {
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }),
        color: typeof color === "function" ? color(theme) : color,
      },
    };
  }
);

export function RpiText<C = "div">({
  type = "p2",
  weight = "regular",
  ellipsis,
  color,
  className,
  ...props
}: PolymorphicComponentProps<C, RpiTextProps & Omit<BoxProps, "color">>) {
  const { classes, cx } = useRpiTextStyles({ type, weight, ellipsis, color });

  // @ts-expect-error legacy type issues
  return <Box className={cx(classes.root, className)} {...props} />;
}
